//imports
import { all } from 'redux-saga/effects';

//Views
import activitiesTabSagas from 'Modules/activities/.components/tab/redux/saga';
import activitiesMainSagas from 'Modules/activities/views/main/redux/saga';
import generalDetailsSagas from 'Modules/activities/.components/generalDetails/redux/saga';
import changeListSagas from 'Modules/activities/.components/changeList/redux/saga';

//merge sagas
export default function* rootSaga() {
    yield all([
        activitiesTabSagas(),
        activitiesMainSagas(),
        generalDetailsSagas(),
        changeListSagas(),
    ]);
}